import {createContext} from "react";

export const SignContractsContext = createContext({
  signContractsActiveTab: 0,
  setSignContractsActiveTab: () => {},
  currentUser: null,
});
